<script>
  export default {
    methods: {
      precioById(id) {
        const item = this.$store.getters['PreciosVigentes/all'].find(item => item.id === id)
        return item ? item : null
      },
      precioByVigencia(value) {
        let fechaParam = new Date(value);
        let candidatos = this.$store.getters['PreciosVigentes/all'].filter(item => new Date(item.vigencia) <= fechaParam)
        .sort((a, b) => new Date(b.vigencia) - new Date(a.vigencia)); // Más reciente primero

        return candidatos.length ? candidatos[0] : null;
      },
      precioSubsidioById(id) {
        const item = this.$store.getters['PreciosVigentes/all'].find(item => item.id === id);
        return item ? item.subsidio : 0
      },
      precioUsuarioById(id) {
        const item = this.$store.getters['PreciosVigentes/all'].find(item => item.id === id)
        return item ? item.usuario : 0
      },
      precioPlenoById(id) {
        const item = this.$store.getters['PreciosVigentes/all'].find(item => item.id === id)
        return item ? item.pleno : 0
      },
    }
  };
</script>
